<template>
  <div class="row custom-calender hidden">
    <div class="my-1 px-md-3 px-0" :class="`col-md-${cols}`">
      <label for="from">{{ $t("products.checkIn") }}</label>
      <div class="calendar-input-group">
        <b-form-input
          readonly
          class="input check-in has-icon g-input"
          type="text"
          v-model="date.checkIn"
          :disabled="disabled"
          id="from"
        />
      </div>
    </div>
    <div class="my-1 px-md-3 px-0" :class="`col-md-${cols}`">
      <label for="to">{{ $t("products.checkOut") }}</label>
      <div class="calendar-input-group">
        <b-form-input
          readonly
          class="input check-out has-icon g-input"
          type="text"
          v-model="date.checkOut"
          :disabled="disabled"
          id="to"
        />
      </div>
    </div>
    <div
      v-if="distributorType === 'B'"
      class="my-1 px-md-3 px-0"
      :class="`col-md-${cols}`"
    >
      <label for="guests">{{ $t("listing.guests") }}</label>
      <div class="calendar-input-group guests" ref="guestField">
        <b-form-input
          @click="toggleGuestDropdown"
          readonly
          class="input check-out has-icon g-input"
          type="text"
          :value="guestFieldText"
          :disabled="disabled"
          id="guests"
        />
        <div
          v-if="showGuestDropdown"
          class="bg-white shadow-lg py-2 px-3 mt-2 rounded guest-dropdown"
          ref="guestDropdown"
        >
          <div v-if="provider === 'NUITEE'" class="options">
            <div class="d-flex justify-content-between align-items-center my-3">
              <div>{{ $t("listing.adults") }}</div>
              <div class="d-flex align-items-center">
                <button
                  :disabled="nuiteeGuestsData.adults === 1"
                  @click="decrementNuiteeGuestData('adults')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  -
                </button>
                <div class="mx-3 small count-field">
                  {{ nuiteeGuestsData.adults }}
                </div>
                <button
                  :disabled="nuiteeGuestsData.adults === 30"
                  @click="incrementNuiteeGuestData('adults')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  +
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center my-3">
              <div>{{ $t("listing.children") }}</div>
              <div class="d-flex align-items-center">
                <button
                  :disabled="nuiteeGuestsData.children === 0"
                  @click="decrementNuiteeGuestData('children')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  -
                </button>
                <div class="mx-3 small count-field">
                  {{ nuiteeGuestsData.children }}
                </div>
                <button
                  :disabled="nuiteeGuestsData.children === 10"
                  @click="incrementNuiteeGuestData('children')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  +
                </button>
              </div>
            </div>
            <ValidationObserver ref="observer">
              <div class="row" v-if="nuiteeGuestsData.children > 0">
                <div
                  class="col-6 my-1"
                  :class="{ 'pl-1': i % 2 === 0, 'pr-1': i % 2 !== 0 }"
                  v-for="i in nuiteeGuestsData.children"
                  :key="i"
                >
                  <ValidatedInput
                    border
                    :name="`age.${i}`"
                    type="single-select"
                    v-model="nuiteeGuestsData.childrenAges[i - 1]"
                    :options="childrenOptions"
                    :placeholder="$t('listing.selectAge')"
                    rules="required"
                  />
                </div>
              </div>
            </ValidationObserver>
            <div class="d-flex justify-content-between align-items-center my-3">
              <div>{{ $t("listing.rooms") }}</div>
              <div class="d-flex align-items-center">
                <button
                  :disabled="nuiteeGuestsData.rooms === 1"
                  @click="decrementNuiteeGuestData('rooms')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  -
                </button>
                <div class="mx-3 small count-field">
                  {{ nuiteeGuestsData.rooms }}
                </div>
                <button
                  :disabled="nuiteeGuestsData.rooms === 30"
                  @click="incrementNuiteeGuestData('rooms')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  +
                </button>
              </div>
            </div>
          </div>
          <div v-else class="options p-1">
            <div class="d-flex justify-content-between align-items-center my-3">
              <div>{{ $t("listing.persons") }}</div>
              <div class="d-flex align-items-center">
                <button
                  :disabled="ehotelGuestData.persons === 1"
                  @click="decrementEhotelGuestData('persons')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  -
                </button>
                <div class="mx-3 small count-field">
                  {{ ehotelGuestData.persons }}
                </div>
                <button
                  :disabled="ehotelGuestData.persons === 30"
                  @click="incrementEhotelGuestData('persons')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  +
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center my-3">
              <div>{{ $t("listing.rooms") }}</div>
              <div class="d-flex align-items-center">
                <button
                  :disabled="ehotelGuestData.rooms === 1"
                  @click="decrementEhotelGuestData('rooms')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  -
                </button>
                <div class="mx-3 small count-field">
                  {{ ehotelGuestData.rooms }}
                </div>
                <button
                  :disabled="ehotelGuestData.rooms === 30"
                  @click="incrementEhotelGuestData('rooms')"
                  class="btn g-primary-button btn-sm px-2 py-0"
                >
                  +
                </button>
              </div>
            </div>
          </div>
          <div class="p-1">
            <button
              @click="searchAvailability"
              class="btn btn-outline-main btn-block"
            >
              {{ $t("listing.done") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="mt-auto my-1 px-md-3 px-0 mt-3 d-md-none d-block"
      :class="`col-md-${cols}`"
      v-if="!promoDisabled && showPromoField"
    >
      <div class="calendar-input-group promo">
        <b-form-input
          class="input check-out has-icon"
          type="text"
          :placeholder="$t('property.promoCode')"
          v-model="promoCode"
        />
      </div>
    </div>
    <div
      ref="submitButton"
      class="mt-auto my-1 px-md-3 px-0"
      :class="`col-md-${cols}`"
    >
      <PrimaryButton
        @click="searchAvailability"
        :text="$t('listing.search')"
        full
        :loading="disabled"
        class="py-2 mt-3"
      />
    </div>
    <template v-if="!promoDisabled">
      <div
        v-if="!showPromoField"
        class="col-md-12 mt-3 promo cursor-pointer px-md-3 px-0"
        @click="showPromoField = true"
      >
        <img src="../../assets/icons/promo.svg" class="mr-1" alt="promo" />
        <span>{{ $t("property.havePromo") }}</span>
      </div>
      <div v-else class="col-md-4 mt-3 d-md-block d-none">
        <div class="calendar-input-group promo">
          <b-form-input
            class="input check-out has-icon"
            type="text"
            :placeholder="$t('property.promoCode')"
            v-model="promoCode"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";

import DateRangePicker from "../../helpers/datepicker/index";
export default {
  name: "BookingEngineDateSelector",
  props: {
    checkIn: {
      type: String,
      required: false,
    },
    checkOut: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formatted: {
      type: Boolean,
      default: false,
    },
    currencyCode: {
      type: String,
      required: false,
    },
    currencySymbol: {
      type: String,
      required: false,
    },
    distributorType: {
      type: String,
      required: false,
    },
    showImmediately: {
      type: Boolean,
      default: false,
    },
    provider: {
      type: String,
      required: false,
    },
    guestData: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapState("property", ["settings"]),
    childrenOptions() {
      return Array.from({ length: 18 }, (_, i) => ({
        id: i.toString(),
        text: this.$tc("listing.yearsOld", i, { count: i }),
      }));
    },
    promoDisabled() {
      return this.distributorType !== "A";
    },
    guestFieldText() {
      if (this.distributorType === "B") {
        let rooms, persons;
        if (this.provider === "NUITEE") {
          const { adults, children } = this.nuiteeGuestsData;
          rooms = this.nuiteeGuestsData.rooms;
          persons = adults + children;
        } else {
          rooms = this.ehotelGuestData.rooms;
          persons = this.ehotelGuestData.persons;
        }
        return this.$t("listing.roomsAndGuests", {
          rooms: this.$tc("listing.roomSummary", rooms),
          guests: this.$tc("listing.personSummary", persons),
        });
      } else {
        return "";
      }
    },
    cols() {
      return this.distributorType === "A" ? "4" : "3";
    },
  },
  data() {
    return {
      datapicker: null,
      showPromoField: false,
      promoCode: "",
      date: {
        checkIn: null,
        checkOut: null,
      },
      showGuestDropdown: false,
      ehotelGuestData: {
        rooms: 1,
        persons: 2,
      },
      nuiteeGuestsData: {
        rooms: 1,
        adults: 2,
        children: 0,
        childrenAges: [],
      },
    };
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  mounted() {
    setTimeout(() => this.initDatepicker(), 100);
    document.addEventListener("click", this.handleClickOutside);
  },
  methods: {
    ...mapActions("property", ["getPropertyCalendarData"]),
    async initDatepicker() {
      const { checkIn, checkOut, settings } = this;
      if (checkIn && checkOut) {
        this.date.checkIn = this.formatted
          ? moment(checkIn, "YYYY-MM-DD").format("DD MMM YYYY")
          : moment(checkIn, "DD-MM-YYYY").format("DD MMM YYYY");
        this.date.checkOut = this.formatted
          ? moment(checkOut, "YYYY-MM-DD").format("DD MMM YYYY")
          : moment(checkOut, "DD-MM-YYYY").format("DD MMM YYYY");
      }

      const shouldShowImmediately =
        this.showImmediately && this.distributorType === "A";

      const dateOptions = {
        currency: this.currencyCode,
        currencySymbol: settings?.additionalFeatures?.currencySymbol
          ? this.currencySymbol
          : "",
        numberFormat: settings.numberFormat || [],
        smartCalendar:
          this.distributorType === "A" &&
          !!settings?.additionalFeatures?.smartCalendar,
        showCalendarPrice:
          this.distributorType === "A" &&
          !!settings?.additionalFeatures?.prices,
        defaultFromDate: this.date.checkIn
          ? moment(this.date.checkIn, "DD MMM YYYY").toDate()
          : null,
        defaultToDate: this.date.checkOut
          ? moment(this.date.checkOut, "DD MMM YYYY").toDate()
          : null,
      };

      this.datapicker = new DateRangePicker("#from", "#to", dateOptions);
      await this.datapicker.ready;

      const startDate = this.date.checkIn
        ? moment(this.date.checkIn, "DD MMM YYYY").toDate()
        : new Date();

      if (this.distributorType === "A") {
        const calendarData = await this.getPropertyCalendarData({
          property_id: this.$route.params.id,
          start_date: moment(startDate).subtract(1, "days").format("YYYY-MM-DD"),
          end_date: moment(startDate).add(1, "years").format("YYYY-MM-DD"),
        });

        if (this.datapicker) {
          const minStays = calendarData.min_stays || {};
          this.datapicker.setPriceData(calendarData.prices || {});
          this.datapicker.setMinLosData(minStays);

          const minLos = minStays[moment(startDate).format("YYYY-MM-DD")] || 1;
          if (!dateOptions.defaultToDate && minLos > 1) {
            this.date.checkOut = moment(startDate)
              .add(minLos, "days")
              .format("DD MMM YYYY");
          }
        }

        if (shouldShowImmediately && this.datapicker) {
          this.datapicker.show();
        }
      } else if (this.distributorType === "B") {
        if (
          this.guestData &&
          this.guestData.nuiteeGuestsData &&
          this.guestData.ehotelGuestData
        ) {
          if (this.provider === "NUITEE") {
            this.nuiteeGuestsData = this.guestData.nuiteeGuestsData;
          } else {
            this.ehotelGuestData = this.guestData.ehotelGuestData;
          }
        }
      }
    },
    handleClickOutside(event) {
      const guestField = this.$refs.guestField;
      const submitButton = this.$refs.submitButton;
      if (
        guestField &&
        submitButton &&
        !guestField.contains(event.target) &&
        !submitButton.contains(event.target) &&
        this.showGuestDropdown
      ) {
        this.showGuestDropdown = false;
      }
    },
    toggleGuestDropdown() {
      this.showGuestDropdown = !this.showGuestDropdown;
    },
    async searchAvailability() {
      const observer = this.$refs.observer;
      if (observer) {
        const isValid = await observer?.validate();
        if (!isValid) {
          return;
        }
      }
      this.showGuestDropdown = false;
      const { ehotelGuestData, nuiteeGuestsData } = this;
      const { checkIn, checkOut } = this.date;
      if (checkIn && checkOut) {
        this.$emit("search", {
          ehotelGuestData,
          nuiteeGuestsData,
          checkIn: moment(checkIn, "DD MMM YYYY").format("YYYY-MM-DD"),
          checkOut: moment(checkOut, "DD MMM YYYY").format("YYYY-MM-DD"),
          promoCode: this.promoCode,
        });
      }
    },
    decrementEhotelGuestData(field) {
      if (this.ehotelGuestData[field] > 1) {
        this.ehotelGuestData[field]--;
      }
    },
    incrementEhotelGuestData(field) {
      if (this.ehotelGuestData[field] < 30) {
        this.ehotelGuestData[field]++;
      }
    },
    decrementNuiteeGuestData(field) {
      if (field === "children" && this.nuiteeGuestsData[field] > 0) {
        this.nuiteeGuestsData[field]--;
        this.nuiteeGuestsData.childrenAges.pop();
      } else if (field !== "children" && this.nuiteeGuestsData[field] > 1) {
        this.nuiteeGuestsData[field]--;
      }
    },
    incrementNuiteeGuestData(field) {
      if (field === "children" && this.nuiteeGuestsData[field] < 10) {
        this.nuiteeGuestsData[field]++;
        this.nuiteeGuestsData.childrenAges.push("");
      } else if (field !== "children" && this.nuiteeGuestsData[field] < 30) {
        this.nuiteeGuestsData[field]++;
      }
    },
  },
};
</script>

<style>
@import "../../assets/css/calendar.css";

/* 16px minimum prevents iOS Safari from zooming on focus */
@media screen and (max-width: 600px) {
  .custom-calender .calendar-input-group input.g-input,
  .custom-calender .calendar-input-group #from,
  .custom-calender .calendar-input-group #to {
    font-size: 16px !important;
  }
}
</style>
